import api from "./api";
import { Post } from "@/types";
import { generatePost } from "@/mocks/handlers";
import { getDocIdFromSlug } from "@/lib/utils";

export interface PostsResponse {
  data: Post[];
  has_more: boolean;
  nextCursor: string | null;
  total?: number;
  message?: string; // 用于处理API返回的提示信息
  success?: boolean; // 用于标识请求是否成功
}

export interface PostFilters {
  page?: number;
  limit?: number;
  tagSlug?: string;
  channel?: string;
  search?: string;
  docIds?: string[];
}

// Get paginated posts
export const fetchPosts = async (
  filters: PostFilters = {},
  headers?: any
): Promise<PostsResponse> => {
  const { page = 1, limit = 10, tagSlug, channel, search, docIds } = filters;

  const params: any = {
    cstart: String((page - 1) * limit),
    cend: String(page * limit),
  };

  if (tagSlug) params.tag = tagSlug;
  if (channel) params.channel = channel.charAt(0).toUpperCase() + channel.slice(1);
  if (search) params.search = search;
  if (docIds) params.his_dup_ids = docIds
  return api.post("/feed", params, {
    headers: headers || {},
  });
};

// Get single post by slug
export const fetchPostBySlug = async (slug: string, headers?: any): Promise<Post> => {
  const id = getDocIdFromSlug(slug);

  const res = await api.get(`/content/detail`, {
    params: {
      docid: id,
    },
    headers: headers || {},
  });
  return res.data
};

// Get related posts
export const fetchRelatedPosts = async (
  postId: string,
  limit: number = 3
): Promise<Post[]> => {
  return api.get(`/posts/${postId}/related?limit=${limit}`);
};

// Get posts by tag
export const fetchPostsByTag = async (
  hashtag: string,
  page: number = 1,
  limit: number = 10,
  headers?: any
): Promise<PostsResponse> => {

  const params: any = {
    cstart: String((page - 1) * limit),
    cend: String(page * limit),
    hashtag: hashtag,
  };

  return api.post("/tag-feed", params, {
    headers: headers || {},
  });
};

// Get posts by category
export const fetchPostsByCategory = async (
  channel: string,
  page: number = 1,
  limit: number = 10,
  docIds: string[] = [],
  headers?: any
): Promise<PostsResponse> => {
  return fetchPosts({ channel: channel, page, limit, docIds }, headers);
};

// Get posts by following
export const fetchPostsByFollowing = async (
  page: number = 1,
  limit: number = 10,
  headers?: any
): Promise<PostsResponse> => {
  return api.get("/following-feed", {
    params: {
      cstart: String((page - 1) * limit),
      cend: String(page * limit),
    },
    headers: headers || {},
  });
};

// Get featured posts
export const fetchFeaturedPosts = async (
  limit: number = 5
): Promise<Post[]> => {
  return api.get(`/posts/featured?limit=${limit}`);
};

// Delete post
export const deletePost = async (postId: string): Promise<void> => {
  return api.delete(`/posts/${postId}`);
};

// Like/unlike post
export const togglePostLike = async (
  postId: string
): Promise<{ liked: boolean; likeCount: number }> => {
  return api.post(`/posts/${postId}/like`);
};

// Share post
export const sharePost = async (
  postId: string
): Promise<{ shareCount: number }> => {
  return api.post(`/posts/${postId}/share`);
};

// Get post statistics
export const fetchPostStats = async (
  postId: string
): Promise<{
  likes: number;
  comments: number;
  shares: number;
  views: number;
}> => {
  return api.get(`/posts/${postId}/stats`);
};


export const likeDocService = async (params: any) => {
  return api.get("/interact/thumbs-up", {
    params: {
      ...params,
    }
  });
};
export const unLikeDocService = async (params: any) => {
  return api.get("/interact/thumbs-up", {
    params: {
      ...params,
      prev_state: "thumbsup"
    }
  });
};
